import { createElement } from 'src/app/core/helpers/dom';
import Tooltip from 'src/app/project/features/tooltip/Tooltip';
import { ECustomFieldType } from 'src/app/project/modules/custom-fields/custom-field-types-enums';
import { GET_CUSTOM_FIELDS } from 'src/app/project/modules/custom-fields/custom-fields.store';
import { setFormulaTooltipTitle } from 'src/app/project/modules/custom-fields/utils/create-formula-tooltip';
import { TColumn } from '../../../columns/column.model';
import { createDescriptionTooltipElement } from './create-description-tooltip-element';
import { createHeaderTooltip } from './create-header-tooltip';
import { createIntegrationImage } from './create-integration-image';
import { createSortingIndicatorElement } from './create-sorting-indicator-element';
import { getTitleClassName } from './get-title-class-name';

export function createHeaderCustomFieldCellInnerElement(
  child: HTMLElement | string,
  column: TColumn,
): HTMLElement {
  const nameElement = createNameElement(column, child);
  const integrationNameElement = createIntegrationImage(column);
  const descriptionTooltipElement = createDescriptionTooltipElement(column);

  const sortingElement = column?.sortOrder
    ? createSortingIndicatorElement(column.sortIndex, column.sortOrder)
    : '';

  const cellNameElement = createCellNameElement(
    nameElement,
    descriptionTooltipElement,
    sortingElement,
  );

  setFormulaTooltip(column, cellNameElement);

  const classList = getElementClassList(integrationNameElement);

  const cellInnerElement = createCellInnerElement(
    classList,
    integrationNameElement,
    cellNameElement,
  );

  setHeaderTooltip(column, nameElement);

  return cellInnerElement;
}

function createNameElement(column: TColumn, child: string | HTMLElement): HTMLElement {
  return createElement<HTMLElement>('span', {
    attrs: {
      class: getTitleClassName(column),
      id: 'sortingElement',
    },
    children: [child],
  });
}

function createCellInnerElement(
  classList: string,
  integrationNameElement: string | HTMLElement,
  cellNameElement: HTMLElement,
): HTMLElement {
  return createElement<HTMLElement>('div', {
    attrs: {
      class: classList,
    },
    children: [integrationNameElement, cellNameElement],
  });
}

function createCellNameElement(
  nameElement: HTMLElement,
  descriptionTooltipElement: string | HTMLElement,
  sortingElement: string | HTMLElement,
): HTMLElement {
  return createElement<HTMLElement>('span', {
    attrs: {
      class: 'table__head__cell--inner',
    },
    children: [nameElement, descriptionTooltipElement, sortingElement],
  });
}

function getElementClassList(integrationNameElement: string | HTMLElement): string {
  let classList =
    'table__cell__inner__namedColumn table__cell__inner table__cell__inner--noPadding table__head__cell';

  if (integrationNameElement) {
    classList += ' table__cell__inner__namedColumn--integration';
  }
  return classList;
}

function setFormulaTooltip(column: TColumn, cellNameElement: HTMLElement): void {
  if (!column.customFieldIds?.length) {
    return;
  }

  const customFieldId = column.customFieldIds[0];
  const customFields = GET_CUSTOM_FIELDS();
  const fieldType = customFields[customFieldId]?.type;

  if (fieldType !== ECustomFieldType.FORMULA) {
    return;
  }

  setFormulaTooltipTitle(customFieldId, GET_CUSTOM_FIELDS()).then((tooltipText) => {
    const tooltip = new Tooltip({
      options: { content: tooltipText, allowHTML: true },
      title: '',
      mobileTooltip: false,
      trimTooltip: false,
      childTooltip: false,
      element: cellNameElement,
    });

    tooltip.createTooltip();
  });
}

function setHeaderTooltip(column: TColumn, cellNameElement: HTMLElement): void {
  createHeaderTooltip(column.name, cellNameElement);
}
